import React from 'react';
import PropTypes from 'prop-types';
import { FDStack } from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { PillarLozenge } from '../PillarLozenge';
import { PillarActionItemList } from './PillarActionItemList';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('actionItems', { _component: () => PillarActionItemList }, overrideReadOnly);

export const Pillar = ({ resource: pillarResource, onClickActionItem, prePlan }) => {
  return (
    <FDStack direction="column" spacing={1}>
      <PillarLozenge resource={pillarResource} />
      <MetaControl
        resource={pillarResource}
        attrName={'actionItems'}
        metaOverrideSet={metaOverrideSet}
        CustomProps={{
          prePlan,
          pillarResource,
          onClickActionItem,
        }}
      />
    </FDStack>
  );
};

Pillar.defaultProps = {
};

Pillar.propTypes = {
  resource: PropTypes.object.isRequired,
  onClickActionItem: PropTypes.func.isRequired,
  prePlan: PropTypes.bool.isRequired,
};
